$ = jQuery.noConflict()

$(document).ready(function () {
  const setAos = (selector, animation, options = {}) => {
    $(selector).each(function (index) {
      const $element = $(this)

      if (!$element.attr('data-aos')) {
        $element.attr('data-aos', animation)
      }

      Object.entries(options).forEach(([key, value]) => {
        if (!$element.attr(`data-aos-${key}`)) {
          const optionValue = typeof value === 'function' ? value(index, $element) : value
          $element.attr(`data-aos-${key}`, optionValue)
        }
      })
    })
  }

  setAos('[data-section] > *:first-child:not(video):not(source)', 'fade-up', {
    duration: 700,
    offset: 90,
  })

  setAos('section h1, section h2, .hero-principal h1, .hero-sobrio h1', 'fade-up', {
    duration: 700,
    offset: 80,
  })

  setAos(
    [
      '.service-card',
      '.solution-card',
      '.engine-card',
        '.product-card',
        '.payment-showcase__list li',
        '.sector-carousel .soft-card',
      '.client-testimonial',
      '.trust-card',
      '.press-card',
      '.experience-card',
      '.contact-card',
      '.metric-card',
    ].join(', '),
    'fade-up',
    {
      delay: (index) => Math.min((index % 4) * 90, 270),
      duration: 700,
      offset: 80,
    }
  )

  setAos(
    [
      '.hero-principal__media',
      '.hero-principal__visual',
      '.hero-sobrio__media',
        '.product-card__visual',
        '.payment-showcase__visual',
      '.client-testimonial__media',
      '.experience__media',
      '.trust-card img',
      '.press-card img',
    ].join(', '),
    'zoom-in',
    {
      delay: 120,
      duration: 750,
      offset: 90,
    }
  )

  setAos('section p, section .eyebrow, section .solution-pill', 'fade-up', {
    delay: 80,
    duration: 650,
    offset: 70,
  })

  AOS.init({
    once: true,
    duration: 700,
    easing: 'ease-out-cubic',
    offset: 80,
  })

  $(window).on('load', function () {
    AOS.refreshHard()
  })
})
